// import { HashRouter as Router, Routes, Route } from "react-router-dom";
// import { useEffect, useState } from "react";
// import AboutPage from "./pages/Aboutpage";
// import CheckoutPage from "./pages/CheckoutPage";
// import OrderTypePage from "./pages/OrderTypePage";
// import CartPage from "./pages/CartPage";
// import InactivityHandler from "./components/InactivityHandler";
// import PhonePage from "./pages/phoneno";
// import PopupPage from "./pages/PopupPage";
// import useBlockThreeFingerSwipe from "./hooks/useBlockThreeFingerSwipe";
// import OfflineOverlay from "./components/OfflineOverlay";
// import QREntryPage from "./pages/QREntryPage";
// import OrderTrackingPage from "./pages/OrderTrackingPage";
// import { Navigate } from "react-router-dom";
// import QRCodeAdmin from "./pages/QrcodeAdmin";

// // ✅ Unique ID for this tab — survives route changes, dies when tab closes   
// const MY_TAB_ID = `tab_${Date.now()}_${Math.random()}`;

// function App() {
//   useBlockThreeFingerSwipe();
//   const [isBlocked, setIsBlocked] = useState(false);

//  useEffect(() => {
//   const ACTIVE_TAB_KEY = "sos_active_tab_id";
//   const Device_KEY = "sos_tab_Key";

//   // ✅ Only clear cart if this is a NEW tab (not a refresh)
//   const isNewTab = !sessionStorage.getItem("tab_initialized");
//   if (isNewTab) {
//     localStorage.removeItem("cart");
//     localStorage.removeItem("selectedFreeItems");
//     localStorage.removeItem("allowedFreeQty");
//     sessionStorage.setItem("tab_initialized", "true");
//   }

//   localStorage.setItem(ACTIVE_TAB_KEY, MY_TAB_ID);

//   const heartbeat = setInterval(() => {
//     if (localStorage.getItem(ACTIVE_TAB_KEY) === MY_TAB_ID) {
//       localStorage.setItem(Device_KEY, `${MY_TAB_ID}_${Date.now()}`);
//     }
//   }, 1000);

//   const handleStorage = (e) => {
//     if (e.key === ACTIVE_TAB_KEY && e.newValue !== MY_TAB_ID) {
//       setIsBlocked(true);
//       clearInterval(heartbeat);
//     }
//   };

//   window.addEventListener("storage", handleStorage);

//   return () => {
//     window.removeEventListener("storage", handleStorage);
//     clearInterval(heartbeat);
//   };
// }, []);

// function RequireSession({ children }) {
//   const compId     = localStorage.getItem("compId");
//   const storeId    = localStorage.getItem("StoreId");
//   const typeId     = localStorage.getItem("ordertypeId");
//   const verifiedAt = localStorage.getItem("qrVerifiedAt");

//   const SESSION_WINDOW_MS = 60 * 60 * 1000; // 1 hour — tune to your dine-in duration

//   const isValid =
//     compId && storeId && typeId && verifiedAt &&
//     (Date.now() - parseInt(verifiedAt, 10) < SESSION_WINDOW_MS);

//   if (!isValid) {
//     return <Navigate to="/" replace />;
//   }
//   return children;
// }
//  if (isBlocked) {
//   return (
//     <div style={{
//       position: "fixed",
//       inset: 0,
//       background: "#1a1a1a",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       zIndex: 99999,
//       fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//     }}>
//       <div style={{
//         background: "#ffffff",
//         borderRadius: 24,
//         padding: "40px 32px",
//         maxWidth: 360,
//         width: "90%",
//         textAlign: "center",
//         boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
//       }}>
//         <div
//   style={{
//     width: 72,
//     height: 72,
//     borderRadius: "50%",
//     background: "#fdecea",
//     border: "2px solid #c8102e",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     margin: "0 auto 20px",
//   }}
// >
//   <svg
//     width="32"
//     height="32"
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="#c8102e"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//   >
//     <path d="M10 13a5 5 0 0 0 7.07 0l2.12-2.12a5 5 0 0 0-7.07-7.07L10 5" />
//     <path d="M14 11a5 5 0 0 0-7.07 0L4.81 13.12a5 5 0 0 0 7.07 7.07L14 19" />
//   </svg>
// </div>
//         <h2 style={{
//           fontSize: 20,
//           fontWeight: 700,
//           color: "#1a1a1a",
//           margin: "0 0 10px",
//         }}>
//           Session Moved
//         </h2>
//         <p style={{
//           color: "#555",
//           fontSize: 14,
//           lineHeight: 1.6,
//           margin: "0 0 6px",
//         }}>
//           This page is now active in a newer tab.
//         </p>
//         <p style={{
//           color: "#aaa",
//           fontSize: 12,
//           margin: "0 0 28px",
//         }}>
//           This tab is no longer active.
//         </p>
//         <div style={{ height: 1, background: "#f0f0f0", margin: "0 0 20px" }} />
//         <button
//           onClick={() => {
//   window.location.href = 'about:blank';
// }}
//           style={{
//             background: "#c8102e",
//             color: "#fff",
//             border: "none",
//             padding: "13px 0",
//             borderRadius: 12,
//             fontSize: 14,
//             fontWeight: 700,
//             cursor: "pointer",
//             width: "100%",
//             letterSpacing: "0.3px",
//           }}
//         >
//           Close This Tab
//         </button>
//       </div>
//     </div>
//   );
// }

//   return (
//     <>
//       {/* <OfflineOverlay /> */}
//       <Router>
//         {/* <InactivityHandler timeout={5 * 60 * 1000} /> */}
//         <Routes>
//           <Route path="/" element={<QREntryPage />} />
//           <Route path="/menu" element={<RequireSession><AboutPage /></RequireSession>} />
//           <Route path="/checkout" element={<RequireSession><CheckoutPage /></RequireSession>} />
//           <Route path="/order-type" element={<RequireSession><OrderTypePage /></RequireSession>} />
//           <Route path="/phoneNo" element={<RequireSession><PhonePage /></RequireSession>} />
//           <Route path="/popup" element={<RequireSession><PopupPage /></RequireSession>} />
//           <Route path="/cart" element={<RequireSession><CartPage /></RequireSession>} />
//           <Route path="/order-tracking" element={<RequireSession><OrderTrackingPage /></RequireSession>} />
//           <Route path="/kadherbhaiQr" element={<QRCodeAdmin/>} />
    
          
//         </Routes>
//       </Router>
//     </>
//   );
// }

// export default App;

import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import AboutPage from "./pages/Aboutpage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderTypePage from "./pages/OrderTypePage";
import CartPage from "./pages/CartPage";
import InactivityHandler from "./components/InactivityHandler";
import PhonePage from "./pages/phoneno";
import PopupPage from "./pages/PopupPage";
import useBlockThreeFingerSwipe from "./hooks/useBlockThreeFingerSwipe";
import OfflineOverlay from "./components/OfflineOverlay";
import QREntryPage from "./pages/QREntryPage";
import OrderTrackingPage from "./pages/OrderTrackingPage";
import QRCodeAdmin from "./pages/QrcodeAdmin";
import MaintenancePage from "./pages/MaintenancePage";
import { getStoreStatus } from "./api/service";

const MY_TAB_ID = `tab_${Date.now()}_${Math.random()}`;
const MAINTENANCE_POLL_MS = 8000; // ~8s — near-instant without hammering the API

function App() {
  useBlockThreeFingerSwipe();
  const [isBlocked, setIsBlocked] = useState(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const pollRef = useRef(null);

  // ── existing tab-lock logic (unchanged) ──
  useEffect(() => {
    const ACTIVE_TAB_KEY = "sos_active_tab_id";
    const Device_KEY = "sos_tab_Key";

    const isNewTab = !sessionStorage.getItem("tab_initialized");
    if (isNewTab) {
      localStorage.removeItem("cart");
      localStorage.removeItem("selectedFreeItems");
      localStorage.removeItem("allowedFreeQty");
      sessionStorage.setItem("tab_initialized", "true");
    }

    localStorage.setItem(ACTIVE_TAB_KEY, MY_TAB_ID);

    const heartbeat = setInterval(() => {
      if (localStorage.getItem(ACTIVE_TAB_KEY) === MY_TAB_ID) {
        localStorage.setItem(Device_KEY, `${MY_TAB_ID}_${Date.now()}`);
      }
    }, 1000);

    const handleStorage = (e) => {
      if (e.key === ACTIVE_TAB_KEY && e.newValue !== MY_TAB_ID) {
        setIsBlocked(true);
        clearInterval(heartbeat);
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
      clearInterval(heartbeat);
    };
  }, []);

  // ══════════════════════════════════════════
  //  ✅ MAINTENANCE MODE — global, instant switch
  //  Polls store-status while a storeId exists
  //  (i.e. user has already scanned/entered a
  //  store) and flips the WHOLE app to the
  //  maintenance screen the moment it's on,
  //  regardless of which route they're on.
  // ══════════════════════════════════════════
  const checkMaintenance = async () => {
    const storeId = localStorage.getItem("StoreId");
    if (!storeId) return; // nothing scanned yet — QREntryPage handles it on scan
    try {
      const res = await getStoreStatus(storeId);
      setIsMaintenance(!!res?.isMaintenance);
    } catch {
      // network hiccup — don't flip state on a failed check
    }
  };

  useEffect(() => {
    checkMaintenance(); // check immediately on load

    pollRef.current = setInterval(checkMaintenance, MAINTENANCE_POLL_MS);

    // ── Faster reaction when the tab regains focus ──
    const onVisible = () => {
      if (document.visibilityState === "visible") checkMaintenance();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      clearInterval(pollRef.current);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  function RequireSession({ children }) {
    const compId     = localStorage.getItem("compId");
    const storeId    = localStorage.getItem("StoreId");
    const typeId     = localStorage.getItem("ordertypeId");
    const verifiedAt = localStorage.getItem("qrVerifiedAt");

    const SESSION_WINDOW_MS = 60 * 60 * 1000;

    const isValid =
      compId && storeId && typeId && verifiedAt &&
      (Date.now() - parseInt(verifiedAt, 10) < SESSION_WINDOW_MS);

    if (!isValid) {
      return <Navigate to="/" replace />;
    }
    return children;
  }

  if (isBlocked) {
    return (
      <div style={{
        position: "fixed", inset: 0, background: "#1a1a1a",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 99999, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}>
        <div style={{
          background: "#ffffff", borderRadius: 24, padding: "40px 32px",
          maxWidth: 360, width: "90%", textAlign: "center",
          boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
        }}>
          <div style={{
            width: 72, height: 72, borderRadius: "50%", background: "#fdecea",
            border: "2px solid #c8102e", display: "flex", alignItems: "center",
            justifyContent: "center", margin: "0 auto 20px",
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c8102e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10 13a5 5 0 0 0 7.07 0l2.12-2.12a5 5 0 0 0-7.07-7.07L10 5" />
              <path d="M14 11a5 5 0 0 0-7.07 0L4.81 13.12a5 5 0 0 0 7.07 7.07L14 19" />
            </svg>
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#1a1a1a", margin: "0 0 10px" }}>
            Session Moved
          </h2>
          <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6, margin: "0 0 6px" }}>
            This page is now active in a newer tab.
          </p>
          <p style={{ color: "#aaa", fontSize: 12, margin: "0 0 28px" }}>
            This tab is no longer active.
          </p>
          <div style={{ height: 1, background: "#f0f0f0", margin: "0 0 20px" }} />
          <button
            onClick={() => { window.location.href = 'about:blank'; }}
            style={{
              background: "#c8102e", color: "#fff", border: "none", padding: "13px 0",
              borderRadius: 12, fontSize: 14, fontWeight: 700, cursor: "pointer",
              width: "100%", letterSpacing: "0.3px",
            }}
          >
            Close This Tab
          </button>
        </div>
      </div>
    );
  }

  // ── Maintenance mode wins over everything except the tab-lock screen above ──
if (isMaintenance) {
  return (
    <MaintenancePage
      storeName={localStorage.getItem("StoreName")}
      logo={localStorage.getItem("logo")}
      onRetry={checkMaintenance}
    />
  );
}

  return (
    <>
      {/* <OfflineOverlay /> */}
      <Router>
        {/* <InactivityHandler timeout={5 * 60 * 1000} /> */}
        <Routes>
          <Route path="/" element={<QREntryPage />} />
          <Route path="/menu" element={<RequireSession><AboutPage /></RequireSession>} />
          <Route path="/checkout" element={<RequireSession><CheckoutPage /></RequireSession>} />
          <Route path="/order-type" element={<RequireSession><OrderTypePage /></RequireSession>} />
          <Route path="/phoneNo" element={<RequireSession><PhonePage /></RequireSession>} />
          <Route path="/popup" element={<RequireSession><PopupPage /></RequireSession>} />
          <Route path="/cart" element={<RequireSession><CartPage /></RequireSession>} />
          <Route path="/order-tracking" element={<RequireSession><OrderTrackingPage /></RequireSession>} />
          <Route path="/kadherbhaiQr" element={<QRCodeAdmin/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;